import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  Alert,
  AlertTitle,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import { ClientSearchResult } from "@/api";
import { useTranslation } from "@/translations";

import { useStyles } from "./ClientDuplicateWarning.styles";
import { ClientDuplicateTableColumnWidth } from "./ClientDuplicateWarning.utils";
import { DuplicateRow } from "./components/DuplicateRow";

interface Props {
  duplicates: ClientSearchResult[];
}

export function ClientDuplicateWarning({ duplicates }: Props) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Alert severity="warning" variant="outlined" sx={classes.alert} icon={false}>
      <Box sx={classes.header}>
        <WarningAmberIcon color="warning" fontSize="small" sx={classes.icon} />
        <Box>
          <AlertTitle>{t("clients.create.duplicateTitle")}</AlertTitle>
          {t("clients.create.duplicateDescription")}
        </Box>
      </Box>
      <TableContainer sx={classes.table}>
        <Table size="small" sx={classes.tableElement}>
          <TableHead sx={classes.tableHead}>
            <TableRow>
              <TableCell sx={{ width: ClientDuplicateTableColumnWidth.firstName }}>
                {t("clients.create.name")}
              </TableCell>
              <TableCell sx={{ width: ClientDuplicateTableColumnWidth.lastName }}>
                {t("clients.create.lastName")}
              </TableCell>
              <TableCell sx={{ width: ClientDuplicateTableColumnWidth.birthday }}>
                {t("clients.create.birthday")}
              </TableCell>
              <TableCell sx={{ width: ClientDuplicateTableColumnWidth.caseNumber }}>{t("clients.table.id")}</TableCell>
              <TableCell>{t("clients.create.duplicateAddress")}</TableCell>
              <TableCell sx={{ width: ClientDuplicateTableColumnWidth.chevron }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {duplicates.map((client) => (
              <DuplicateRow key={client.clientId} client={client} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Alert>
  );
}
